import { onMounted, onUnmounted, watch } from 'vue';
import { buildStructuredDataGraph, injectStructuredDataIntoHtml as injectStructuredData } from '../utils/projectStructuredData';
const buildSiteInput = (siteConfig) => {
    const origin = typeof window !== 'undefined' ? window.location.origin : 'https://example.com';
    const contact = siteConfig?.contact;
    return {
        baseUrl: origin,
        projectName: siteConfig?.project?.name || 'Restaurant',
        shortName: siteConfig?.project?.name || 'Restaurant',
        description: siteConfig?.seo?.description || siteConfig?.content?.description || '',
        phone: contact?.phone || '',
        email: contact?.email || '',
        logoUrl: siteConfig?.branding?.logoUrl || '',
        ogImageUrl: siteConfig?.seo?.ogImage || siteConfig?.branding?.heroImageUrl || '',
        street: contact?.street || '',
        houseNumber: contact?.houseNumber || '',
        zipCode: contact?.zipCode || '',
        city: contact?.city || '',
        country: 'DE'
    };
};
const isMenuRoute = (path) => {
    const normalized = path.replace(/\/+$/, '') || '/';
    return normalized === '/' || normalized.endsWith('/speisekarte') || normalized === '/speisekarte';
};
export function useStarterStructuredData(options) {
    const scriptIds = [];
    const applyStructuredData = () => {
        if (typeof document === 'undefined')
            return;
        const { siteConfig, routePath, menuCategories = [] } = options();
        if (siteConfig?.seo?.noIndex)
            return;
        const input = buildSiteInput(siteConfig);
        const includeMenu = isMenuRoute(routePath);
        const schemas = buildStructuredDataGraph(input, menuCategories, { includeMenu });
        schemas.forEach((schema, index) => {
            const id = `structured-data-${index}`;
            scriptIds.push(id);
            injectStructuredData(schema, id);
        });
    };
    const cleanup = () => {
        if (typeof document === 'undefined')
            return;
        scriptIds.forEach((id) => document.getElementById(id)?.remove());
        scriptIds.length = 0;
    };
    onMounted(() => {
        applyStructuredData();
        watch(options, () => {
            cleanup();
            applyStructuredData();
        }, { deep: true });
    });
    onUnmounted(cleanup);
    return { applyStructuredData, cleanup };
}
export { injectStructuredData };
